import "./style.css";

import "alpinejs";
import "glider-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "./gsaplib/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

function initNews() {
  //News carousel
  new Glider(document.querySelector(".glider"), {
    draggable: true,
    arrows: {
      prev: ".glider-prev",
      next: ".glider-next",
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

function initAnimation() {
  //Header text animation
  let split = new SplitText(".animated-title", { type: "words" });
  let animation = gsap.timeline({});
  gsap.set(".animated-title,.subscribe", { autoAlpha: 1 });
  animation.from(split.words, {
    opacity: 0,
    y: 400,
    ease: "power4.out",
    stagger: 0.15,
    delay: 0.25,
  });
  animation.from(".subscribe", {
    opacity: 0,
    y: 20,
    stagger: 0.25,
    duration: 0.75,
  });

  //Use .fade-bottom class to animate
  gsap.set(".fade-bottom", { autoAlpha: 0 });
  ScrollTrigger.batch(".fade-bottom", {
    onEnter: (elements, triggers) => {
      gsap
        .timeline()
        .from(elements, { y: 20, stagger: 0.25, duration: 0.75 })
        .to(elements, { autoAlpha: 1, duration: 0.75 }, 0);
    },
    start: "top 80%",
    once: true,
  });

  //Partner logo animation
  gsap.set("#partners img", { autoAlpha: 0 });
  ScrollTrigger.batch("#partners img", {
    onEnter: (elements, triggers) => {
      gsap
        .timeline()
        .from(elements, {
          yPercent: 100,
          duration: 0.8,
          ease: "slow",
          stagger: 0.2,
        })
        .to(elements, { autoAlpha: 1 }, "<");
    },
    start: "top 90%",
    once: true,
  });

  //Header images animation
  let tl = gsap.timeline();
  tl.fromTo(
    "#img1,#img2",
    {
      scale: 0.1,
      ease: "back",
    },
    {
      scale: 1.4,
      ease: "back",
    },
    0
  ).to(
    "#img1, #img2",
    {
      repeat: -1,
      yoyo: true,
      x: () => getRandomInt(1, 10),
      y: () => getRandomInt(1, 10),
      rotate: (i, element, elements) => {
        let random = getRandomInt(-5, 5);
        console.log(random);
        return gsap.getProperty(element, "rotation") + random;
      },
      duration: 5,
      ease: "slow",
      stagger: 0.9,
    },
    "<"
  );

  gsap.to(".animate-image", {
    repeat: -1,
    yoyo: true,
    x: "+=5",
    y: "-=15",
    rotate: (i, element, elements) => {
      let random = getRandomInt(-5, 5);
      return gsap.getProperty(element, "rotation") + random;
    },
    duration: 5,
    ease: "slow",
    stagger: 0.9,
  });

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }
}

window.addEventListener("DOMContentLoaded", initNews);
window.addEventListener("load", initAnimation);

/*
  Old code animation
  tl.fromTo(
    "#img1",
    {
      scale: 0.1,
      ease: "back",
    },
    {
      scale: 1.4,
      ease: "back",
    },
    0
  )
    .fromTo(
      "#img2",
      {
        scale: 0.1,
        ease: "back",
      },
      {
        scale: 1.4,
        ease: "back",
        yPercent: 10,
      },
      0
    )
    .to(
      "#img1",
      {
        repeat: -1,
        yoyo: true,
        x: () => getRandomInt(1, 10),
        y: () => getRandomInt(1, 10),
        rotate: (nn) => {
          return gsap.getProperty("#img1", "rotation") + getRandomInt(-5, 5);
        },
        duration: 5,
        ease: "slow",
      },
      "<"
    )
    .to(
      "#img2",
      {
        repeat: -1,
        yoyo: true,
        x: () => getRandomInt(1, 10),
        y: () => getRandomInt(1, 10),
        rotate: (nn) => {
          return gsap.getProperty("#img2", "rotation") + getRandomInt(-5, 5);
        },
        duration: 5,
        ease: "slow",
      },
      "<"
    );
    */
